import { Component, Input, OnInit } from '@angular/core'
import { MediaInterface } from '../../interfaces'

@Component({
  selector: 'dmmp-search-error',
  templateUrl: './search-error.component.html'
})
export class SearchErrorComponent implements OnInit {

  @Input() module
  @Input() defaultClass
  @Input() identifier
  medias: MediaInterface[] = [
    { style: 'thumbnail', media: '(max-width:421px)' },
    { style: 'medium', media: '(min-width:600px)' },
  ]

  constructor() { }

  ngOnInit(): void {
  }

}
